// @ts-check
import * as typesAPI from '../models/api/models-api'
import { HttpStatus } from '../models/converter/convert'
import { TypeParts } from '../models/components/models-parts'
import { Const } from '../const/const'
import { VueHelper } from './vue'

export class ErrorHelper {
    /**
     * APIエラー処理
     * @param {typesAPI.APIResponse} response
     * @param {import('vue').ComponentCustomProperties} v
     * @param {TypeParts[]} parts
     * @returns {boolean} 正常フラグ
     */
    static apiErrorHandler(response, v, parts = []) {
        if (response.status == HttpStatus.OK.code) {
            return true
        }

        if (response.status == HttpStatus.FOUND.code) {
            // Responseに戻り先URL(return_toが存在する場合リダイレクト)
            if (response.data.return_to) {
                location.replace(response.data.return_to)
            }
            return true
        }
        if (response.status == HttpStatus.BAD_REQUEST.code) {
            if (response.data.type == Const.KEY_RESPONSE_BAD_REQUEST_TYPE_AUTH_KEY) {
                return false
            } else if (response.data.type == Const.KEY_RESPONSE_BAD_REQUEST_TYPE_VALIDATE) {
                // clear error message
                parts.forEach((parts) => (parts.error = ''))

                const errors = response.data.validate_result
                errors.forEach((error) => {
                    for (const key in error) {
                        const value = error[key]
                        /**
                         * @type {TypeParts | undefined}
                         */
                        const input = parts.find((parts) => parts.name == key)
                        if (input) {
                            if (value == 'required') {
                                input.error = input.label + 'が未入力です。'
                            } else if (value == 'match') {
                                input.error = input.label + 'に誤りがあります。'
                            } else if (value == 'email_format') {
                                input.error = 'メールアドレスの形式で入力してください。'
                            } else if (value == 'send_email_invalid_parameter') {
                                input.error = '有効なメールアドレスを入力してください。'
                            } else if (value.startsWith('length_max')) {
                                input.error = input.label + 'は' + error['length'] + '文字以内で入力してください。'
                            } else if (value.startsWith('length_min')) {
                                input.error = input.label + 'は' + error['length'] + '文字以上で入力してください。'
                            } else if (value.startsWith('length_equal')) {
                                input.error = input.label + 'は' + error['length'] + '文字で入力してください。'
                            } else if (value == 'password_format') {
                                input.error = '入力されたパスワードに使用できない文字が含まれています。'
                            } else if (value == 'password_same_char3') {
                                input.error = '入力されたパスワードが同一文字の連続などの不正な形式です。'
                            } else if (value == 'password_use_email') {
                                input.error = 'メールアドレスは使用できません。'
                            } else if (value == 'all_full_width') {
                                input.error = input.label + 'は' + '全角文字で入力してください。'
                            } else if (value == 'all_full_width_kana' || value == 'all_full_width_kana_number') {
                                input.error = input.label + 'は' + '全角カタカナで入力してください。'
                            } else if (value == 'date_format') {
                                input.error = '生年月日に誤りがあります。'
                            } else if (value == 'validate_date_future') {
                                input.error = '生年月日に正しい日付を指定してください。'
                            } else if (value == 'number_format') {
                                input.error = input.label + 'は' + '数値で入力してください。'
                            } else if (value == 'sex_type') {
                                input.error = '性別の選択が不正です。'
                            } else if (value == 'state_type') {
                                input.error = '都道府県の選択が不正です。'
                            } else if (value == 'range_cp932') {
                                input.error = input.label + 'に当サイトで扱えない文字が含まれています。'
                            }
                        } else {
                            VueHelper.transition(v, '/error')
                        }
                        break
                    }
                })
            }
            return false
        }

        if (
            response.status == HttpStatus.NOT_FOUND.code ||
            response.status == HttpStatus.CONFLICT.code ||
            response.status == HttpStatus.GONE.code
        ) {
            return false
        }
        // それ以外のエラーはエラーページへ遷移
        VueHelper.transition(v, '/error')
        return false
    }

    /**
     * APIエラー・タイムアウト処理
     * @param {typesAPI.APIResponse} response
     * @param {import('vue').ComponentCustomProperties} v
     * @returns {boolean} 正常フラグ
     */
    static apiErrorAndTimeoutHandler = (response, v) => {
        if (ErrorHelper.apiErrorHandler(response, v)) {
            return true
        }
        if (response.status == HttpStatus.NOT_FOUND.code) {
            VueHelper.transitionErrorLINETimeout(v)
            return false
        }
    }
}
